var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex justify-between align-center"},[_c('div',{class:_vm.leftClasses},[_vm._t("left")],2),_c('div',{class:_vm.rightClasses},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }